import { createSelector } from "reselect";
import { intersection } from "lodash";
import { getSubLineItems } from "./subLineItems";

// Check for required changes by equipmentLine (aka productLine aka productTag)
// return all subLineItems have a de-facto selected (default or selected) option
// that does not match at least one of the activatedProductLine.
export const getDivergentProductLineSubLineItems = createSelector(
  [getSubLineItems],
  subLineItems => {
    return acceptedProductLineTags => {
      return acceptedProductLineTags.length > 0
        ? subLineItems
            .filter(({ isOptional, hasBuyerSelection }) => {
              return isOptional ? hasBuyerSelection : true; // filter out every optional that is not activated
            })
            .filter(
              ({ defactoSelectedOption }) =>
                intersection(
                  defactoSelectedOption?.productTags,
                  acceptedProductLineTags
                ).length === 0
            )
        : undefined;
    };
  }
);

// returns a delta that represents the required changes
// Array<{ subLineItem, oldInvalidOption, newValidOption}>
export const getSubLineItemAdjustmentDeltaForProductLine = createSelector(
  [getDivergentProductLineSubLineItems],
  getDivergentSubLineItems => {
    return acceptedProductLineTags =>
      getDivergentSubLineItems?.(acceptedProductLineTags)
        ?.map(subLineItem => ({
          subLineItem,
          oldInvalidOption: subLineItem.defactoSelectedOption,
          newValidOption: subLineItem.options.find(({ productTags }) =>
            productTags.some(productTag =>
              acceptedProductLineTags.includes(productTag)
            )
          )
        }))
        .filter(({ newValidOption, oldInvalidOption }) => {
          return !(
            !newValidOption && oldInvalidOption?.productTags?.length === 0
          );
        });
  }
);
